export default {
  state: {
    isLogged: false,
    user: null,
  },
}
